/* eslint-disable @gorazdo/preact/prefer-classname */
import { Component, h } from 'preact'
import SaveCustomViewModal from './SaveCustomViewModal'
import DeleteCustomViewModal from './DeleteCustomViewModal'
import ButtonControl from '../../../preact-components/button-control'
import Tooltip from '../../ui-components/Tooltip'

interface Props {
  isCustomView: boolean
  customViewName: string
  onShareView: () => void
  onSaveCustomView: (newCustomViewName?: string) => Promise<void> | void
  onDeleteCustomView: () => Promise<void> | void
  errorMessage: string
}

interface State {
  showSaveModal: boolean
  showDeleteModal: boolean
  radioInput: string
  inputName: string
}

const createNewCustomView = 'Create new custom view'
const updateExistingCustomView = 'Save changes to the current view'

class CustomViewActions extends Component<Props, State> {
  constructor (props: Props) {
    super(props)

    this.state = {
      showSaveModal: false,
      showDeleteModal: false,
      radioInput: props.isCustomView ? updateExistingCustomView : createNewCustomView,
      inputName: ''
    }

    this.onSaveViewClicked = this.onSaveViewClicked.bind(this)
    this.onDeleteViewClicked = this.onDeleteViewClicked.bind(this)
    this.closeSaveModal = this.closeSaveModal.bind(this)
    this.closeDeleteModal = this.closeDeleteModal.bind(this)
    this.onCustomViewNameChanged = this.onCustomViewNameChanged.bind(this)
    this.onRadioButtonChanged = this.onRadioButtonChanged.bind(this)
    this.onSaveCustomView = this.onSaveCustomView.bind(this)
  }

  onSaveViewClicked () {
    this.setState({ showSaveModal: true })
  }

  onDeleteViewClicked () {
    this.setState({ showDeleteModal: true })
  }

  closeSaveModal () {
    this.setState({ showSaveModal: false })
  }

  closeDeleteModal () {
    this.setState({ showDeleteModal: false })
  }

  onCustomViewNameChanged (e: ChangeEvent) {
    this.setState({ inputName: e.target.value })
  }

  onRadioButtonChanged (option: string) {
    this.setState({ radioInput: option })
  }

  onSaveCustomView () {
    const { radioInput, inputName } = this.state
    const { onSaveCustomView } = this.props
    onSaveCustomView(radioInput === createNewCustomView ? inputName : undefined)
  }

  render () {
    const {
      isCustomView,
      customViewName,
      onShareView,
      onDeleteCustomView,
      errorMessage
    } = this.props
    const {
      showSaveModal,
      showDeleteModal,
      inputName,
      radioInput
    } = this.state
    return (
      <div className='overview__views-container'>
        <div className='control-header__action-buttons'>
          {isCustomView &&
            <ButtonControl
              onClick={this.onDeleteViewClicked}
              title='Delete'
              variant='warning'
              class='qa-delete-view'
              newStyle
              size='medium'
            />}
          <Tooltip
            trigger={<ButtonControl
              onClick={onShareView}
              title='Share view'
              class='qa-share-view'
              newStyle
              size='medium'
                     />}
            tooltipMessage='Share current filter and column settings with your team mates via URL'
            qaClasses='qa-save-view-tooltip'
            withArrow
            position='center'
          />
          <ButtonControl
            onClick={this.onSaveViewClicked}
            title='Save view'
            variant='success'
            class='save-view'
            newStyle
            size='medium'
          />
        </div>
        <SaveCustomViewModal
          customViewName={inputName}
          customViewRadioInput={radioInput}
          isCustomView={isCustomView}
          onClose={this.closeSaveModal}
          onCustomViewNameChanged={(e: ChangeEvent) => this.onCustomViewNameChanged(e)}
          onRadioButtonChanged={(option: string) => this.onRadioButtonChanged(option)}
          onSaveCustomView={this.onSaveCustomView}
          radioOptions={[updateExistingCustomView, createNewCustomView]}
          showModal={showSaveModal}
          errorMessage={errorMessage}
        />
        <DeleteCustomViewModal
          showModal={showDeleteModal}
          customViewName={customViewName}
          onClose={this.closeDeleteModal}
          onDeleteCustomView={onDeleteCustomView}
        />
      </div>
    )
  }
}

export default CustomViewActions
